export default __webpack_public_path__ + "assets/images/7620da7bee7ef9e97b9b89dd122abd52.svg";